var Hogan = require('hogan.js');
var config = require('../config');
var utils = require('./utils');

var $tooltip = $('.map-tooltip-wrapper');

import { tooltipTemplate } from './templates';

function update(data, color) {
  //var dataAndLabels = $.extend({}, uiLabels[config.language].tooltip, data, { color: color });
  $tooltip.html(tooltipTemplate.render(data)).show();
}

function show() {
  $tooltip.show();
}

function hide(evt) {
  // i daut it
  if(utils.isDefined(evt)){
    if(utils.isDefined(evt.preventDefault)){
      evt.preventDefault();
    }else if(utils.isDefined(evt.originalEvent)){
      evt.originalEvent.preventDefault();
    }
  }
  
  $tooltip.hide();
}

function updatePos(evt) {

  if(window.innerWidth < 768){
    /*return $tooltip.css({
      top: 'auto',
      left: '2%'
    }).show();*/

    return $tooltip.hide();
  }

  var pos = evt.containerPoint;

  $tooltip.css({
    top: (pos.y - 50) + 'px',
    left: (pos.x + 20) + 'px'
  }).show();
}

module.exports = {
  update : update,
  show : show,
  hide : hide,
  updatePos : updatePos
}